<template>
  <div id="storey-title">
    <template v-if="storey.ShowType == Enum_StoreyShowType.PictureStorey">
      <div class="storey-title-picture">
        <div class="largeTitle">
          {{ storey.StoreyTitle }} <span class="span">{{ storey.StoreyDescription }}</span>
        </div>
        <div v-if="storey.IsShowMore" class="more-gary" @click="showMoreRouter">
          <span class="moreFont">查看更多</span>
        </div>
      </div>
    </template>
    <template v-else-if="storey.ShowType == Enum_StoreyShowType.SingleGoodsStorey">
      <div class="storey-title-hotgoods">
        <div class="largeTitle">
          {{ storey.StoreyTitle }} <span class="span">{{ storey.StoreyDescription }}</span>
        </div>
        <div v-if="storey.IsShowMore" class="more-gary" @click="showMoreRouter">
          <span class="moreFont">查看更多</span>
        </div>
      </div>
    </template>
    <template v-else-if="storey.ShowType == Enum_StoreyShowType.TimesStorey">
      <div
        class="storey-title-newgoods"
        :style="{backgroundImage:`url(${storey.StoreyTitleBackgroundImage})`,backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}"
      >
        <div class="days">
          {{ firstTime[4] }}
        </div>
        <div class="time">
          <div class="span">{{ firstTime[0] }}</div>
          <div class="span-title">:</div>
          <div class="span">{{ firstTime[1] }}</div>
          <div class="span-title">:</div>
          <div class="span">{{ firstTime[2] }}</div>
        </div>
        <div class="more" @click="showMoreRouter" />
      </div>
    </template>
    <template v-else>
      <div
        class="storey-title-picture"
        :style="{backgroundImage:`url(${storey.StoreyTitleBackgroundImage})`,backgroundRepeat:'no-repeat',backgroundSize:'100% 100%'}"
      >
        <div class="goodsTitle">
          {{ storey.StoreyTitle }} <span class="span gary999">{{ storey.StoreyDescription }}</span>
        </div>
        <div v-if="storey.IsShowMore" class="more" @click="showMoreRouter">
          <span class="moreFont">查看更多</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
import moment from 'moment'

export default {
  name: 'StoreyTitleTemplate',
  mixins: [BaseMixin],
  props: { storey: { type: Object, default() { return null } }},
  data() {
    return {
      firstTime: [0, 0, 0, 0, 0],
      timer: {},
      goodsActivity: {}
    }
  },
  created() {
    const product = this.storey.OutStoreyItemsDtos[0].Goods

    if (product) {
      this.goodsActivity = this._analysisGoodsActivity(
        product.SalesPromotions
      )

      let productTime = product.NewProductTime

      if (this.fromPage == 'isArriving') {
        productTime = product.EstimatedTime
      } else if (this.goodsActivity) {
        productTime = this.goodsActivity.FirstEnd?.EndTime || ''
      }

      if (productTime) {
        this.timer = setInterval(() => {
          const array = this._analysisActivityDiffTime(productTime, moment())
          const firstTime = this._setTimerArr(array[1])
          let flag = true
          const constDays = array[0].length > 1 ? array[0] : '0' + array[0]
          firstTime.push(constDays)
          firstTime.push(array[0])
          firstTime.forEach(t => {
            if (Number(t) < 0) {
              clearInterval(this.timer)
              flag = false
            }
          })
          if (flag) {
            this.firstTime = firstTime
          }
        }, 1000)
      }
    }
  },
  methods: {
    moment,
    // 跳转更多
    showMoreRouter: function() {
      if (this.storey.MoreLinkType != this.Enum_LinkType.StoreyProductList) {
        this._jump(this._getTurnUrl(this.storey.MoreLinkType, this.storey.MoreLinkValue), this.storey.MoreLinkValue)
      } else {
        this.$router.push({ name: this._getTurnUrl(this.storey.MoreLinkType, this.storey.MoreLinkValue), params: { storey: this.storey }})
      }
    }
  }
}
</script>

<style lang="less">
  // #storey-title {

  //   .storey-title-picture {
  //     background: #ffffff;
  //     display: flex;
  //     flex-direction: row;
  //     justify-content: space-between;
  //     padding: 20px 20px;
  //     width: 1200px;

  //     .goodsTitle,
  //     .largeTitle {
  //       font-size: 26px;
  //       font-weight: 600;
  //       color: rgba(34, 34, 34, 1);

  //       .span {
  //         font-size: 16px;
  //         font-weight: 400;
  //         color: rgba(153, 153, 153, 1);
  //       }
  //     }

  //     .goodsTitle {
  //       color: #FFFFFF;

  //       .span {
  //         color: #FFFFFF
  //       }
  //     }

  //     .more,
  //     .more-gary {
  //       text-align: right;
  //       padding-right: 25px;
  //       cursor: pointer;
  //       position: relative;

  //       >.moreFont {
  //         font-size: 14px;
  //         font-weight: 400;
  //         color: rgba(153, 153, 153, 1);
  //         line-height: 30px;
  //       }

  //       >span::after {
  //         content: '';
  //         position: absolute;
  //         width: 22px;
  //         height: 22px;
  //         margin-left: 7px;
  //         top: 4px;
  //       }
  //     }

  //     .more>.moreFont {
  //       color: #ffffff;
  //     }

  //     .more-gary>span::after {
  //       background: url('../../assets/storey/in_gary.png') no-repeat center;
  //       background-size: cover;
  //     }

  //     .more>span::after {
  //       background: url('../../assets/storey/in.png') no-repeat center;
  //       background-size: cover;
  //     }

  //     .more:hover {
  //       span::after {
  //         background: url('../../assets/storey/in_hover.png') no-repeat center;
  //         background-size: cover;
  //       }
  //     }

  //     .more-gary:hover {
  //       >span::after {
  //         background: url('../../assets/storey/in_gary_hover.png') no-repeat center;
  //         background-size: 20px 20px;
  //       }

  //       >.moreFont {
  //         color: rgba(15, 110, 233, 1);
  //       }
  //     }
  //   }

  //   .storey-title-newgoods {
  //     min-width: 251px;
  //     height: 530px;

  //     .days {
  //       position: relative;
  //       top: 274px;
  //       left: 42px;
  //       font-size: 16px;
  //       font-weight: 600;
  //       color: rgba(255, 255, 255, 1);
  //     }

  //     .time {
  //       position: relative;
  //       top: 294px;
  //       display: flex;
  //       flex-direction: row;
  //       justify-content: space-between;
  //       margin: 0 35px;

  //       >.span {
  //         background: #3352E9;
  //         width: 40px;
  //         height: 40px;
  //         border-radius: 1px;
  //         line-height: 40px;
  //         font-size: 24px;
  //         color: rgba(255, 255, 255, 1);
  //       }

  //       >.span-title {
  //         line-height: 35px;
  //         font-size: 24px;
  //         font-weight: 600;
  //         color: rgba(255, 255, 255, 1);
  //       }
  //     }

  //     .more {
  //       position: relative;
  //       top: 340px;
  //       left: 74px;
  //       min-width: 110px;
  //       width: 110px;
  //       min-height: 30px;
  //       cursor: pointer;
  //     }

  //   }

  //   .storey-title-hotgoods {
  //     background: #ffffff;
  //     display: flex;
  //     flex-direction: row;
  //     justify-content: space-between;
  //     padding: 20px 20px;
  //     /*width: 550px;*/

  //     .largeTitle {
  //       font-size: 26px;
  //       font-weight: 600;
  //       color: rgba(34, 34, 34, 1);

  //       .span {
  //         font-size: 16px;
  //         font-weight: 400;
  //         color: rgba(153, 153, 153, 1);
  //       }
  //     }

  //     .more,
  //     .more-gary {
  //       cursor: pointer;

  //       .moreFont {
  //         font-size: 14px;
  //         color: rgba(153, 153, 153, 1);
  //       }

  //       .moreFont:hover {
  //         color: rgba(15, 110, 233, 1);
  //       }
  //     }
  //   }

  // }
</style>
